import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Input } from '@angular/core';
import { BUILD_DEALER } from '@app/_helpers/configuration';
import { DEFAULT_PRECISION, ENABLE_FO_LINK, MAP_ACCOUNT_LINK, MsgType } from '@app/_helpers/constants';
import { ConfigurationService, ENABLE_FO, MAP_ACCOUNT, NgxToastrService, NotificationResponseFirstFetch, ORDER_BOOK, PORTFOLIO_TERMINATE, SquareoffSocketUpdate, SQUAREOFF_DESCRIPTION, StrategySocketUpdateI, SubjectType } from '@app/_shared';
import { BooksSocketService } from '@app/_shared/providers/websocket/books-socket/books-socket.service';
import { RouteMap } from '@app/_shared/shared.structs';
import { TriggerType, WebApiStrategyResponseType, WebApiStrategyRunningType, WebApiTerminationReasonType } from '../../../../../../../utProto/webApiStrategyEnums_pb';
import { BooksService } from '../../../books/providers/books.service';
import { AlertsResponse } from '../../../dashboard/providers/alerts/alerts.interfaces';
import { BriefPortfolioModel, BriefStrategyCache } from '../../../market-place/providers/market-place/market-place.models';
import { NotificationTabs, NotificationType, NotificaionRead } from '../../components/notifications/notifications.consts';
import { NotificationRequest, NotificationResponse, NotificationStructure, PersistantNotification } from '../../components/notifications/notifications.interface';
import { FailoverWarningComponent } from '@app/_shared/modules/failover-warning/failover-warning.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { map, tap } from 'rxjs/operators';
import { Utils } from '@app/_helpers';
import { NotificaionMsgType } from '../../../../../../../utProto/webEnums_pb';
import { BacktestStatus } from '@app/modules/trading/modules/backtest-detail/providers/backtest.enums';
import { Observable, Subject } from 'rxjs';


class NotificationStruct implements NotificationRequest {
    clientId = '';
    title = '';
    message = '';
    time = 0;
    isRead = false;
    type = NotificationType.Trades;
    route?;

}
@Injectable({
    providedIn: 'root'
})

export class NotificationsService {
    @Input() portfolio: BriefPortfolioModel;
    isNotificationOpen: boolean = false;
    notificationsCache: NotificationResponse[] = [];
    notificationUpdate = new EventEmitter();
    unreadMessages: number = 0;
    userName: string;
    selectedTab: string = NotificationTabs[0];
    BacktestStatus = BacktestStatus;
    isBacktestRunning: boolean = false;
    $persistantNotifications: Observable<PersistantNotification[]>;
    viewLoader = new Subject<boolean>();
    constructor(
        public socketService: BooksSocketService,
        private http: HttpClient,
        private conf: ConfigurationService,
        public booksService: BooksService,
        private snackBar: NgxToastrService,
        private matDialog: MatDialog
    ) {
        // Alerts are not shown in current flow
        this.socketService.getSubject(SubjectType.NOTIFICATIONS).subscribe((socketUpdate) => {
            if (socketUpdate.type === NotificaionRead) {
                this.fetchNotification(this.userName).subscribe(() => {
                    this.updateNotificationCount();
                })
            }
        });
        this.socketService.getSubject(SubjectType.BACKTEST).subscribe((socketUpdate) => {
            this.handleBacktestUpdate(socketUpdate);
        });

        this.socketService.getSubject(SubjectType.STRATEGY).subscribe((socketUpdate: StrategySocketUpdateI) => {
            // Fetch Portfolio Details
            if (!socketUpdate.childStrategyId) {
                const portfolio = BriefStrategyCache.Instance.getPortfolioByUniqueID(socketUpdate.uniqueAlgoName);
                const uniquePortfolioID = socketUpdate.uniqueAlgoName;
                const portfolioId = portfolio?.portfolioID;
                if (socketUpdate.TerminationMessage && !BUILD_DEALER) {
                    // If there are no trades or Portfolio didn't squaredoff then show terminated
                    const desc = socketUpdate.messageDesc ?? PORTFOLIO_TERMINATE;
                    if (!socketUpdate.positionClosed || socketUpdate.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASON_MAX) {
                        let btnText = ORDER_BOOK;
                        let route: any = RouteMap.review;
                        if (socketUpdate.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASON_CLIENT_CODE_NOT_FOUND) {
                            route = ENABLE_FO_LINK;;
                            btnText = ENABLE_FO
                        } else if (socketUpdate.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASON_RMS_OUTCOME_FAILURE) {
                            route = MAP_ACCOUNT_LINK;
                            btnText = MAP_ACCOUNT
                        }
                        this.snackBar.clickableCustomToaster(`${portfolio.portfolioName} | Terminated`, btnText, route, desc, portfolioId, uniquePortfolioID);
                    } else if(!(socketUpdate.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASONTYPE_STG_EXPIRED || socketUpdate.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASONTYPE_INVALID_EXECUTION_DAY)){
                        this.snackBar.clickableCustomToaster(`${portfolio.portfolioName} | Execution complete`, ORDER_BOOK, RouteMap.review, desc, portfolioId, uniquePortfolioID);
                    }
                }

                if ((socketUpdate.message || socketUpdate.TerminationMessage) && !socketUpdate.positionClosed && !socketUpdate.childStrategyId
                    && socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS &&
                    socketUpdate.strategyRunningType != WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING && !BUILD_DEALER) {
                    this.squareOffToast(portfolio.portfolioName);
                }

                this.handleStrategyUpdate(socketUpdate);
            }
        })

        this.socketService.getSubject(SubjectType.manualSquareOff).subscribe((socketUpdate: SquareoffSocketUpdate) => {
            if (socketUpdate.isAutomatedSquareOff && socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL && socketUpdate.automatedSquareOffMsg) {
                const msg = socketUpdate.automatedSquareOffMsg;
                this.matDialog.open(FailoverWarningComponent, {
                    width: '420px',
                    height: 'auto',
                    panelClass: 'FailoverWarning-dialog',
                    data: {
                        message: msg,
                        isSquaredOff: true,
                    },
                });
            }

            if (socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_MANUAL_SQOFF_IN_PROGRESS
                || socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL
                || socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_UNSUCCESSFUL) {
                this.manualSquareOffNotification(socketUpdate);
            }
        })

        this.socketService.getSubject(SubjectType.GLOBALEXIT).subscribe((socketUpdate: StrategySocketUpdateI) => {
            // comman function to create global notification
            this.globalExitNotification(socketUpdate);
        })
    }

    squareOffToast(portfolioName: string) {
        this.snackBar.clickableCustomToaster(`${portfolioName} | Square off Pending`, SQUAREOFF_DESCRIPTION, RouteMap.deployedSection);
    }

    createNotification(request: NotificationRequest) {
        return this.http.post<NotificationResponse>(this.conf.applicationUrls.createNotification, request);
    }

    fetchNotification(userName: string) {
        // Clearing the cache to update the 'isRead' status of notifications
        this.notificationsCache = [];
        return this.http.get<NotificationStructure>(this.conf.applicationUrls.createNotification).pipe(tap(
            res => {
                this.processNotifications(res.notifications);
            }
        ))
    }

    getUnreadMessages(type: string) {
        return this.notificationsCache.filter((notification) => notification.type === type && !notification.isRead).length;
    }

    updateNotificationCount() {
        // instead of increamenting or decreamenting the count one by one, we filter the unread messages.
        // this also help in case of any discrepancy in the count for current cases.
        this.unreadMessages = this.notificationsCache.filter((notification) => !notification.isRead).length;

        this.notificationUpdate.emit(this.unreadMessages);

    }

    markAllAsRead(type: string) {
        let requestType;
        switch (type) {
            case NotificationType.Trades:
                requestType = NotificaionMsgType.NOTIFICAIONMSGTYPE_TERMINATE;
                break;
            case NotificationType.Backtest:
                requestType = NotificaionMsgType.NOTIFICAIONMSGTYPE_BACKTEST;
                break;
            case NotificationType.All:
                requestType = `${NotificaionMsgType.NOTIFICAIONMSGTYPE_TERMINATE},${NotificaionMsgType.NOTIFICAIONMSGTYPE_BACKTEST}`;
                break;
            default:
                break;
        }
        if (this.unreadMessages > 0 && requestType) {
            this.http.put<number>(this.conf.applicationUrls.updateNotification, {}, {
                params: {
                    type: requestType
                }
            }).subscribe((res) => {
                // mark notifications as read only if the response count signifies the same.
                // this amends the current 2 known issues that FE updates the unread message count even though the same is not
                // marked by BE. Hence the count remains same on refresh and sometimes the count goes less than 0
                if (res > 0) {
                    this.notificationsCache.forEach((notification) => {
                        if (type === NotificationType.All || notification.type === type) {
                            notification.isRead = true;
                        }
                    })
                }
                this.updateNotificationCount();
            })
        }
    }

    toggleNotificationSidenav() {
        this.isNotificationOpen = !this.isNotificationOpen;
        if (!this.isNotificationOpen && (this.unreadMessages > 0)) {
            this.markAllAsRead(this.selectedTab);
        }
    }

    getKey(alert: AlertsResponse) {
        return `${alert.market_id}_${alert.security_id}`;
    }
    // Adding Confirmations to cache
    //commented as it is not used
    // handleAlerts(alerts: AlertsResponse[]) {
    //     alerts.forEach(alert => {
    //         const alertsObj = new AlertsModel(alert);
    //         const key = this.getKey(alert);
    //         alertsObj.setSymbolInfo(this.symbolSearchService.symbolInfo(key));
    //         alertsObj.setDisplayMessage();
    //         this.notificationsCache.unshift({
    //             title: alertsObj.display_title,
    //             message: alertsObj.display_message,
    //             time: alertsObj.alert_time,
    //             isRead: false,
    //             class: 'text-positive'
    //         });
    //     });
    // }

    processNotifications(res: NotificationResponseFirstFetch[]) {
        this.viewLoader.next(true);
        res.forEach(el => {
            if (el.msgType === NotificaionMsgType.NOTIFICAIONMSGTYPE_BACKTEST && !el.responseMap.algoName.includes('__')) {
                this.handleBacktestUpdate(el.responseMap, el.isRead)
            } else {
                this.handleStrategyUpdate(el.responseMap, el.isRead, el.msgType);
            }
        });
        this.viewLoader.next(false);
    }

    // Adding strategy state to notifications
    handleStrategyUpdate(socketUpdate: StrategySocketUpdateI, isRead: boolean = false, msgType?: number) {
        if ('portfolioName' in socketUpdate) {
            if (socketUpdate.webApiStrategyResponseType !== WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_BACKTESTING_IN_PROGRESS) {
                let notification = new NotificationStruct();
                switch (socketUpdate.webApiStrategyResponseType) {
                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL:
                        if (socketUpdate.strategyRunningType === WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING) {
                            notification.message = `Backtesting started for ${socketUpdate.algoName.includes('__') ? socketUpdate.strategyName : socketUpdate.portfolioName}`;
                            notification.type = NotificationType.Backtest;
                            notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Backtesting Started`;
                        }
                        else {
                            notification.message = `Refer books to check trades and position`;
                            notification.type = NotificationType.Trades;
                            notification.route = RouteMap.books;
                            notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Execution Started`;
                        }
                        break;

                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS:
                        if (socketUpdate.strategyRunningType === WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING) {
                            notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> Backtesting Completed`;
                            notification.message = `Backtesting completed for ${socketUpdate.algoName.includes('__') ? socketUpdate.strategyName : socketUpdate.portfolioName}`;
                            notification.type = NotificationType.Backtest;
                        }
                        else {
                            if (socketUpdate.strategyTerminationType != WebApiTerminationReasonType.WEBAPITERMINATIONREASON_CLIENT_CODE_NOT_FOUND
                                && socketUpdate.strategyTerminationType != WebApiTerminationReasonType.WEBAPITERMINATIONREASON_RMS_OUTCOME_FAILURE) {
                                notification.route = RouteMap.books;
                            }
                            notification.message = socketUpdate.messageDesc ?? PORTFOLIO_TERMINATE;
                            notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Executed`;
                            notification.type = NotificationType.Trades;
                            if (!socketUpdate.positionClosed || socketUpdate?.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASON_MAX 
                                || socketUpdate?.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASON_FRONT_END) {
                                notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Terminated`;
                            } else if (socketUpdate.positionClosed) {
                                if (socketUpdate.childStrategyId) {
                                    notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Terminated`;
                                }
                                const nameType = socketUpdate.childStrategyId ? socketUpdate.algoName : 'Portfolio';
                                if (socketUpdate.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASON_TP_HIT) {
                                    notification.message = `${nameType} exited on <span class="text-positive font-bold">Target Profit</span> condition`;
                                } else if (socketUpdate.strategyTerminationType === WebApiTerminationReasonType.WEBAPITERMINATIONREASON_SL_HIT) {
                                    notification.message = `${nameType} exited on <span class="text-negative font-bold">Stop Loss</span> condition`;
                                }
                            }
                        }
                        break;

                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_UNSUCCESSFUL:
                        notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> execution unsuccessful`;
                        notification.message = `Execution for Algo ${socketUpdate.portfolioName} was unsuccessful: ${socketUpdate.strategyCustomComment}`;
                        notification.type = NotificationType.Trades;
                        break;

                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_STRATEGY_WAIT:
                        notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> waiting`;
                        notification.message = `Execution for Algo ${socketUpdate.portfolioName} is waiting`;
                        notification.type = NotificationType.Trades;
                        break;

                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_RUN_SUCCESSFUL:
                        notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Resumed`;
                        notification.message = `Check deployed cards section`;
                        notification.type = NotificationType.Trades;
                        notification.route = RouteMap.deployedSection;
                        break;

                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_PAUSE_SUCCESSFUL:
                        notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Paused`;
                        notification.message = `Check deployed cards section`;
                        notification.type = NotificationType.Trades;
                        notification.route = RouteMap.deployedSection;
                        break;
                    
                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_MODIFY_SUCCESSFUL :
                        notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | ${socketUpdate.algoState}`;
                        notification.message = socketUpdate.message ? socketUpdate.message.split('|')[1] : 'Lot multiplier updated successfully';
                        notification.type = NotificationType.Trades;
                        break;
                    
                    case WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_MODIFY_UNSUCCESSFUL :
                        notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | ${socketUpdate.algoState}`;
                        notification.message = socketUpdate.message ? socketUpdate.message.split('|')[1] : 'Strategy modification failed';
                        notification.type = NotificationType.Trades;
                        break;
                    default:
                        if (socketUpdate.strategyRunningType !== WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING) {
                            notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> update`;
                            notification.message = `Update recieved for ${socketUpdate.portfolioName}: ${socketUpdate.strategyCustomComment}`;
                            notification.type = NotificationType.Trades;
                        } else {
                            return;
                        }

                        break;
                }

                notification.time = Utils.manageTimestamp(socketUpdate.timeStamp);
                notification.isRead = isRead;
                this.createNotifications(notification);
                this.squareOffPendingNotification(isRead, socketUpdate);
            }
        } else if ('triggerType' in socketUpdate) {
            this.globalExitNotification(socketUpdate, isRead);
        }

        // check for manual squareoff
        if ((msgType === MsgType.SQUAREOFF) && (socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_MANUAL_SQOFF_IN_PROGRESS
            || socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL
            || socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_UNSUCCESSFUL)) {
            this.manualSquareOffNotification(socketUpdate, isRead);

        }
    }
    handleBacktestUpdate(socketUpdate: any, isRead: boolean = false) {

        let notification = new NotificationStruct();
        if(socketUpdate.algoName?.includes('__')) {
            return;
        }

        const strategy_name = socketUpdate.portfolioName;

        if(socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS || socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL) 
        {
            if (socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS) {
                notification.title = `<span class="text-accent font-bold">${strategy_name}</span> Backtesting Completed`;
                notification.message = `Backtesting completed for ${strategy_name}`;
            } else if (socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_SUCCESSFUL) {
                notification.title = `<span class="text-accent font-bold">${strategy_name}</span> Backtesting Started`;
                notification.message = `Backtesting started for ${strategy_name}`;
            }
            this.isBacktestRunning = false;
            notification.time = socketUpdate.timeStamp ? socketUpdate.timeStamp * 1e3 : (new Date()).getTime();
            notification.isRead = isRead;
            notification.type = NotificationType.Backtest;
            this.createNotifications(notification);
        }
    }

    // Add Squareoff pending notifications
    squareOffPendingNotification(isRead: boolean, socketUpdate?: StrategySocketUpdateI) {
        if (socketUpdate.webApiStrategyResponseType === WebApiStrategyResponseType.WEBAPISTRATEGYRESPONSE_TERMINATE_SUCCESS) {
            if (socketUpdate.strategyRunningType != WebApiStrategyRunningType.WEBAPISTRATEGYRUNNINGTYPE_BACKTESTING &&
                !socketUpdate.positionClosed && !socketUpdate.childStrategyId) {
                let notification = new NotificationStruct();
                notification.title = `<span class="text-accent font-bold">${socketUpdate.portfolioName}</span> | Square off Pending`;
                notification.message = `Check deployed section to take further action.`;
                notification.route = RouteMap.deployedSection;
                notification.time = (new Date()).getTime();
                notification.isRead = isRead;
                this.createNotifications(notification);
            }
        }
    }

    globalExitNotification(socketUpdate: StrategySocketUpdateI, isRead: boolean = false) {
        let notification = new NotificationStruct();
        notification.title = `<span class="text-accent font-bold">Global Exit Settings</span> | Threshold Breached`;
        notification.route = RouteMap.globalExit;
        notification.time = socketUpdate.timeStamp ? socketUpdate.timeStamp * 1e3 : (new Date()).getTime();
        switch (socketUpdate.triggerType) {
            case TriggerType.TRIGGERTYPE_TARGET_PROFIT_EXIT:
                notification.message = `Global Target Profit threshold of Rs ${Utils.localeConverter(Utils.precisionUtil(socketUpdate.targetProfit, DEFAULT_PRECISION), DEFAULT_PRECISION)} has been reached`;
                break;
            case TriggerType.TRIGGERTYPE_STOP_LOSS_EXIT:
                notification.message = `Global Stop Loss threshold of Rs ${Utils.localeConverter(Utils.precisionUtil((socketUpdate.trailingStopLoss - socketUpdate.stopLoss), DEFAULT_PRECISION), DEFAULT_PRECISION)} has been reached`;
                break;
            case TriggerType.TRIGGERTYPE_LOCKED_PROFIT_EXIT:
                socketUpdate.lockProfitAt = typeof socketUpdate.lockProfitAt === 'string' ? parseInt(socketUpdate.lockProfitAt) : socketUpdate.lockProfitAt;
                socketUpdate.trailingLockProfit = typeof socketUpdate.trailingLockProfit === 'string' ? parseInt(socketUpdate.trailingLockProfit) : socketUpdate.trailingLockProfit;
                notification.message = `Global Target Locked Profit threshold of Rs ${Utils.localeConverter(Utils.precisionUtil((socketUpdate.lockProfitAt + socketUpdate.trailingLockProfit), DEFAULT_PRECISION), DEFAULT_PRECISION)} has been reached`;
                break;
            default:
                return;

        }
        notification.isRead = isRead;
        this.createNotifications(notification);
    }

    manualSquareOffNotification(socketUpdate: SquareoffSocketUpdate | StrategySocketUpdateI, isRead: boolean = false) {
        let notification = new NotificationStruct();
        notification.title = `<span class="text-accent font-bold">${socketUpdate.message}</span>`;
        notification.message = socketUpdate.messageDesc;
        notification.route = RouteMap.books;
        notification.time = socketUpdate.timeStamp ? socketUpdate.timeStamp * 1e3 : (new Date()).getTime();
        notification.isRead = isRead;
        this.createNotifications(notification);
    }

    // Save notifications
    async createNotifications(notification: NotificationStruct) {
        notification.clientId = this.userName;
        this.notificationsCache.unshift(notification as any);
        this.updateNotificationCount();
    }

    // Fetch persistant notifications (these will not delete on EOD until user marks them read)
    fetchPersistantNotifications() {
        this.$persistantNotifications = this.http.get<NotificationStructure>(this.conf.applicationUrls.createNotification).pipe(map(res => {
            return res.persistantNotifications;
        }))
        return this.$persistantNotifications;
    }

    // Mark persistant notifications as read
    markPersistantNotificationsAsRead(id: string) {
        return this.http.put(this.conf.applicationUrls.markNotifiactionAsRead, {}, {
            params: {
                id: id
            }
        })
    }

    updateNotificationPreference(request: any) {
        return this.http.post(this.conf.applicationUrls.updateNotificationPreference, request);
    }

    getNotificationPreference(clientId: string) {
        return this.http.get(this.conf.applicationUrls.updateNotificationPreference, {
            params: {
                clientId: clientId
            }
        });
    }
}
